module.exports = fox._r("fonts/promo-social-icon-set.woff?6587jk", __webpack_public_path__ + "fonts/qvLir0m.woff");


//////////////////
// WEBPACK FOOTER
// ./fonts/promo-social-icon-set.woff?6587jk
// module id = 566
// module chunks = 2